<div class="container-fluid">
    <div class="row">
        <div class="col-12">
            <app-rp-breadcrumb [breadcrumbItems]="breadCrumbItems"></app-rp-breadcrumb>

        </div>
    </div>

    <div class="row">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    @if(billHostorydeatils[0].billType == 'Admin Deduction'){
                    <section *ngIf="billHostorydeatils && billHostorydeatils.length>0">
                        <div class="row">
                            <div class="col-lg-12">
                                <accordion [closeOthers]="false" class="accordion custom-accordian-bill"
                                    [isAnimated]="true">

                                    <div *ngFor="let bills of billHostorydeatils; let i = index">
                                        <accordion-group [isOpen]="isAllOpen" class="accordion-item mb-3 panel-open"
                                            #item5>
                                            <div accordion-heading class="d-flex flex-grow-1">
                                                <div class="flex-grow-1 custom-bg-body pt-2 ">
                                                    <div class="d-flex flex-grow-1 align-items-center ms-3">
                                                        <div class="flex-grow-1">
                                                            <img class="utility-img"
                                                                src="../../../../assets/images/brands/group.png">
                                                            <span class="text-primary font-size-16">>Bill Details </span>
                                                        </div>
                                                    </div>
                                                    <div class="row mx-2 mt-3 text-accordian">

                                                        <div class="col-lg-2">
                                                            <div class="mb-3">
                                                                <label class="form-label">Current Bill Date</label>
                                                                <p>{{bills?.billDate!=null?
                                                                    (bills?.billDate | date:'dd MMM yyyy')
                                                                    :'-' }}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-2 ">
                                                            <div class="mb-3">
                                                                <label class="form-label">Total</label>
                                                                <p>{{bills?.totalAmount!=undefined?(bills.totalAmount |
                                                                    currency: 'INR'
                                                                    : 'symbol' : '1.2-2') : '₹0.00'}}

                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="d-flex align-items-center">
                                                    <i class="mdi font-size-24"
                                                        [ngClass]="!item5?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>

                                                </div>

                                            </div>

                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="d-flex justify-content-center">
                                                        <img src="../../../../assets/images/brands/utility.png"
                                                            class="me-2 w-3">
                                                        <p class="text-decoration-underline card-title font-size-16">
                                                            Consumer
                                                            Details</p>
                                                    </div>
                                                    <div class="row mt-4">
                                                        <div class="col-lg-4  mb-3">
                                                            <div class="mb-3">
                                                                <div class="d-flex">
                                                                    <div class="flex-shrink-0 me-1">
                                                                        <img src="../../../../assets/images/brands/user.png"
                                                                            class="w-80">
                                                                    </div>
                                                                    <div class="flex-grow-1">
                                                                        <label class="form-label">Consumer Name</label>
                                                                        <p>{{bills?.consumerName?bills.consumerName:'-'}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-4  mb-3">
                                                            <div class="mb-3">
                                                                <div class="d-flex">
                                                                    <div class="flex-shrink-0 me-1">
                                                                        <img src="../../../../assets/images/brands/apartment.png"
                                                                            class="w-80">
                                                                    </div>
                                                                    <div class="flex-grow-1">
                                                                        <label class="form-label">Flat No.</label>
                                                                        <p>{{bills?.residentialUnit?bills.residentialUnit:'-'}}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div class="col-lg-4  mb-3">
                                                            <div class="mb-3">
                                                                <div class="d-flex">
                                                                    <div class="flex-shrink-0 me-1">
                                                                        <img src="../../../../assets/images/brands/bill.png"
                                                                            class="w-80">
                                                                    </div>
                                                                    <div class="flex-grow-1">
                                                                        <label class="form-label">Bill No.</label>
                                                                        <p>{{bills?.billNo?bills.billNo:'-'}}</p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="col-md-12">
                                                    <div class="d-flex justify-content-around penaltyBill">
                                                        <div class="text-center">
                                                            <p class="font-size-16 font-weight-bolder">Bill Amount</p>
                                                            <p class="font-size-18 font-weight-bold">
                                                                {{bills?.totalUtilityAmount!=undefined?(bills.totalUtilityAmount
                                                                | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>

                                                        </div>
                                                        <div class="text-center" *ngIf="bills.dueAmount>0">
                                                            <p class="font-size-16 font-weight-bolder">Previous Month
                                                                Due Amount</p>
                                                            <p class="font-size-18 font-weight-bold">
                                                                {{bills?.dueAmount!=undefined?(bills.dueAmount
                                                                | currency: 'INR' : 'symbol' : '1.2-2') : '₹0.00'}}</p>
                                                        </div>

                                                        <div class="text-center">
                                                            <p class="font-size-16 font-weight-bolder">Total Bill Amount
                                                            </p>

                                                            <p class="font-size-18 font-weight-bold">
                                                                {{bills?.totalAmount!=undefined?(bills.totalAmount |
                                                                currency: 'INR' :
                                                                'symbol' : '1.2-2') : '₹0.00'}}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>


                                        </accordion-group>
                                    </div>

                                    <accordion-group [isOpen]="isAllOpen" class="accordion-item mb-3 panel-open" #item6>
                                        <div accordion-heading class="d-flex flex-grow-1">

                                            <div class="flex-grow-1 custom-bg-body pt-2 ">
                                                <div class="d-flex flex-grow-1 align-items-center ms-3">
                                                    <div class="flex-grow-1">
                                                        <img class="utility-img"
                                                            src="../../../../assets/images/brands/group.png">
                                                        <span class="text-primary font-size-16">Admin Deductions
                                                        </span>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="d-flex align-items-center">
                                                <i class="mdi font-size-24"
                                                    [ngClass]="!item6?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>
                                            </div>
                                        </div>
                                        <div class="row custom-list-bill-view p-2 rounded mt-2">
                                            <div class="col-lg-12">
                                                <form>
                                                    <div class="row">
                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Bill Type</label>
                                                                <p>{{billHostorydeatils[0]?.billType?billHostorydeatils[0].billType:'-'}}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Amount Deducted </label>
                                                                <p>{{billHostorydeatils[0]?.amountDeducted!=undefined?(billHostorydeatils[0].amountDeducted
                                                                    |
                                                                    currency: 'INR' :
                                                                    'symbol' : '1.2-2') : '₹0.00'}}
                                                                    <!-- amountDeducted -->

                                                                </p>

                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Available Balance </label>
                                                                <p>{{billHostorydeatils[0]?.availableBalance!=undefined?(billHostorydeatils[0].availableBalance
                                                                    |
                                                                    currency: 'INR' :
                                                                    'symbol' : '1.2-2') : '₹0.00'}}


                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Reason </label>
                                                                <p>{{billHostorydeatils[0]?.reason!=undefined?billHostorydeatils[0].reason
                                                                    :''}}


                                                            </div>
                                                        </div>

                                                    </div>

                                                </form>
                                            </div>
                                        </div>


                                    </accordion-group>


                                    <!-- paymnet Deatils  -->
                                    <accordion-group [isOpen]="isAllOpen" class="accordion-item mb-3 panel-open" #item6>
                                        <div accordion-heading class="d-flex flex-grow-1">

                                            <div class="flex-grow-1 custom-bg-body pt-2 ">
                                                <div class="d-flex flex-grow-1 align-items-center ms-3">
                                                    <div class="flex-grow-1">
                                                        <img class="utility-img"
                                                            src="../../../../assets/images/brands/group.png">
                                                        <span class="text-primary font-size-16"> payment Information
                                                        </span>
                                                    </div>

                                                </div>



                                            </div>
                                            <div class="d-flex align-items-center">
                                                <i class="mdi font-size-24"
                                                    [ngClass]="!item6?.isOpen ? 'mdi mdi-chevron-down accor-plus-icon ': 'mdi mdi-chevron-up accor-plus-icon '"></i>
                                            </div>
                                        </div>
                                        <div class="row custom-list-bill-view p-2 rounded mt-2">
                                            <div class="col-lg-12">
                                                <form>
                                                    <div class="row">
                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Mode of Payment</label>
                                                                <p>{{billHostorydeatils[0]?.paymentMode?billHostorydeatils[0].paymentMode:'-'}}
                                                                </p>
                                                            </div>
                                                        </div>

                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Payment link </label>
                                                                <p>
                                                                    <a [href]="billHostorydeatils[0]?.paymentLink || ''"
                                                                        [attr.target]="billHostorydeatils[0]?.paymentLink ? '_blank' : null">
                                                                        {{ billHostorydeatils[0]?.paymentLink ?
                                                                        billHostorydeatils[0].paymentLink :
                                                                        '-' }}
                                                                    </a>
                                                                </p>

                                                            </div>
                                                        </div>


                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Payment ID </label>
                                                                <p>{{billHostorydeatils[0]?.paymentId
                                                                    !=undefined?billHostorydeatils[0].paymentId:'-'}}
                                                                </p>

                                                            </div>
                                                        </div>


                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Order ID</label>
                                                                <p>{{billHostorydeatils[0]?.orderId!=undefined?billHostorydeatils[0].orderId:'-'}}
                                                                </p>

                                                            </div>
                                                        </div>


                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Payment date</label>
                                                                <p>{{billHostorydeatils[0]?.paymentDate!=null?
                                                                    (billHostorydeatils[0].paymentDate | date: 'dd MMM
                                                                    yyyy hh:mm a') :'-' }}
                                                                </p>

                                                            </div>
                                                        </div>


                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Settlement ID </label>
                                                                <p>{{billHostorydeatils[0]?.settlementId!=''?billHostorydeatils[0].settlementId:'-'}}
                                                                </p>

                                                            </div>
                                                        </div>


                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Settlement date</label>
                                                                <p>{{billHostorydeatils[0]?.settlementDate!=null?
                                                                    (billHostorydeatils[0].settlementDate | date: 'dd
                                                                    MMM yyyy hh:mm a') :'-' }}

                                                                </p>

                                                            </div>
                                                        </div>
                                                        <div class="col-lg-3  mb-3">
                                                            <div class="mb-3">
                                                                <label class="form-label">Payment Status</label>
                                                                <p>{{billHostorydeatils[0]?.paymentStatus?billHostorydeatils[0].paymentStatus:'-'}}
                                                                </p>

                                                            </div>
                                                        </div>



                                                    </div>

                                                </form>
                                            </div>
                                        </div>


                                    </accordion-group>


                                </accordion>

                            </div>


                        </div>
                    </section>
                    }
                    @else{

                    <app-bills-view></app-bills-view>
                    }

                </div>
            </div>
        </div>
    </div>
</div>